import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { SocietyLayout } from '../../../SocietyLayout'
import { SocietyManagementTicketSideBarContent } from './SocietyManagementTicketSideBarContent'
import { useFeatures } from '../../../../../hooks/useFeatures'
import { reverseUrl } from '../../../../../navigation/reverseUrl'

export const SocietyManagementTicketLayout = (): React.ReactNode => {
  const { enabledFeatures } = useFeatures()
  const { id } = useParams()

  if (!enabledFeatures.ticket) {
    return <Navigate to={reverseUrl('society:home', { id })} replace />
  }
  return (
    <SocietyLayout
      noContainer
      sidebar={<SocietyManagementTicketSideBarContent />}
    />
  )
}
